export const BASE_PATH = {
    development: "http://localhost:6947",
    test: "",
    staging: "", // veya container/public IP
    prod: "https://api.ozisikb2b.com",
};

class ApiConfiguration {
    
    public static withBasePath(env:any) {
        console.log("Env : " + JSON.stringify(env));
        
        if("test" == env) {
            return BASE_PATH.test;
        }

        if("staging" == env) {
            return BASE_PATH.staging;
        }

        if("prod" == env) {
            return BASE_PATH.prod;
        }

        if("production" == env) {
            return BASE_PATH.prod;
        }

        if("development" == env) {
            return BASE_PATH.development;
        }

        return BASE_PATH.development;
    }

    public static withDefaultHeaders() {
        let authToken = localStorage.getItem("x-ozsk-auth-token");
        return {'x-ozsk-auth-token' : authToken || "nope"};
    }
}

export default ApiConfiguration;